<template>
  <div>
    <div v-if="loadingOverlay === true"><div class="lds-dual-ring"></div></div>
    <div v-else>
      <div class="row">
        <p-button outline type="info" size="sm" round @click="$router.go(-1)">
          <i class="fa fa-chevron-circle-left"></i>
          Back
        </p-button>
      </div>
      <div class="col-md-12">
        <h5>Campaign Content Detail</h5>
      </div>
      <hr/>

      <!-- Campaign Content Detail -->
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12">
                    <div style="width: 100%;height: 100%">
                      <img v-if="campaignContentDetailStore.contentUrl.split('.').pop().toLowerCase().indexOf('jpeg', 'jpg', 'png') !== -1"
                        :src="s3 + '/' + campaignContentDetailStore.contentUrl" alt/>
                      <video v-else controls class="iframe">
                        <source :src="s3 + '/' + campaignContentDetailStore.contentUrl" type="video/mp4" />
                      </video>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5" style="padding-left: 25px;">
                <div class="row" style="margin-top:25px; margin-bottom:25px;">
                  <div class="col-md-12">
                    <badge type="primary">
                      {{campaignContentDetailStore.contentUrl.split('.').pop().toLowerCase().indexOf('jpeg', 'jpg', 'png') !== -1 ? 'Image' : 'Video'}}
                    </badge>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <p>
                      From: 
                      <a target="_blank" :href="'https://instagram.com/' + campaignContentDetailStore.influencerDetails.instagramProfile">
                        @{{campaignContentDetailStore.influencerDetails.instagramProfile}}
                      </a>
                    </p>
                    <p>
                      Status: {{campaignContentDetailStore.status}}
                    </p>
                    <p>
                      Uploaded: {{convertDate(campaignContentDetailStore.dateAdded)}}
                    </p>
                  </div>
                </div>
                <hr/>
                <!-- Actions -->
                <p-button link type="info" round outline size="sm" @click="openDialogChangeStatus('approved')">
                  Approve
                </p-button>                
                <p-button link type="danger" round outline size="sm" @click="openDialogChangeStatus('rejected')">
                  Reject
                </p-button> 
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Notes -->
      <p-button outline type="info" style="margin-left: 2%" size="sm" round @click="openDialogContentNote(null)">
        Message
      </p-button>
      <time-line type="simple" v-if="contentNotesStore">
        <time-line-item inverted badge-type="info" badge-icon="nc-icon nc-send"
          v-for="note in contentNotesStore" :key="note._id" style="margin-top: 15px">
          <div slot="content">
            <div>
              <span>{{ note.user.name }}</span>
              &nbsp;
              <span class="note-date">{{ convertDate(note.lastUpdated) }}</span>
            </div>
            <hr />
            <div>
              <p>{{ note.text }}</p>
            </div>
            <div>
              <span slot="footer">
                <div>
                  <p-button link size="sm" @click="openDialogContentNote(note)">
                    <i class="fa fa-pen"></i> Edit
                  </p-button>
                  <p-button link size="sm" @click="openDialogDeleteContentNote(note)">
                    <i class="fa fa-pen"></i> Delete
                  </p-button>
                </div>
              </span>
            </div>
          </div>
        </time-line-item>
      </time-line>
    </div>
    <!-- Dialog Change Status Campaign Content -->
    <DialogChangeStatus/>
    <!-- Dialog Content Note -->
    <DialogContentNote/>
    <!-- Dialog Delete Content Note -->
    <DialogDeleteContentNote/>
  </div>
</template>

<script>
import store from '@/store/index.js'
import { config } from '@/config/s3-bucket'
import { mapGetters } from 'vuex'
import { convertTimestampToDate } from '@/util/date'
import { Badge, TimeLine, TimeLineItem } from 'src/components/UIComponents'
import DialogChangeStatus from './components/DialogChangeStatus'
import DialogContentNote from './components/DialogContentNote'
import DialogDeleteContentNote from './components/DialogDeleteContentNote'

export default {
  name: 'CampaignContentsBrandDetail',
  components: { Badge, TimeLine, TimeLineItem, DialogChangeStatus, DialogContentNote, DialogDeleteContentNote },
  data() {
    return {
      loadingOverlay: false,
      s3: config.s3Url
    }
  },
  created() {
    this.loadingOverlay = true
    store.dispatch('getDetailOfCampaignContent', this.$route.params.contentId).then(() => {
      this.loadingOverlay = false
    })
    store.dispatch('getContentNoteList', this.$route.params.contentId)
  },
  computed: { 
    ...mapGetters(['campaignContentDetailStore']),
    ...mapGetters(['contentNotesStore'])
  },
  methods: {
    convertDate(timestamp) {
      return convertTimestampToDate(timestamp * 1000)
    },
    openDialogChangeStatus(status) {
      store.commit('openDialogChangeStatus', status)
    },
    openDialogContentNote(contentNote) {
      store.commit('openDialogContentNote', contentNote)
    },
    openDialogDeleteContentNote(note) {      
      store.commit('openDialogDeleteContentNote', {
        contentId: this.$route.params.contentId,
        noteId: note._id,
        text: note.text,
        status: 'archived'
      })
    }
  }
}
</script>

<style scoped src="./style/index.css"/>